import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { meetingInitialState, MeetingStateProps, meetingStateStore } from './meeting-state.store';
import { select } from '@ngneat/elf';
import { MeetingDto } from '@/types/meeting.types';

@Injectable({
  providedIn: 'root',
})
export class MeetingRepository extends BaseStoreRepository<MeetingStateProps, MeetingDto> {
  constructor() {
    super(meetingStateStore.pipe(select(state => state)), meetingStateStore, meetingInitialState);
  }
}
